import { render, staticRenderFns } from "./CreateUpdateModal.vue?vue&type=template&id=fa73254e&scoped=true&"
import script from "./CreateUpdateModal.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateModal.vue?vue&type=style&index=0&id=fa73254e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa73254e",
  null
  
)

export default component.exports